export const ORIGIN = "https://gadulabs.com";
export const CERNIO_URL = "https://getcernio.com";
export const pages = [
  {
    path: "/",
    en: [
      "GADULABS — Product-focused software engineering",
      "GADULABS builds and owns software products. Explore Cernio, our flagship B2B platform, selected corporate web work and early product initiatives.",
    ],
    tr: [
      "GADULABS — Ürün odaklı yazılım geliştirme",
      "GADULABS kendi yazılım ürünlerini geliştirir. Amiral gemisi Cernio’yu, kurumsal web çalışmalarını ve erken aşamadaki ürün girişimlerini keşfedin.",
    ],
  },
  {
    path: "/products/cernio",
    en: [
      "Cernio — B2B company discovery and relevance | GADULABS",
      "Cernio helps exporters discover candidate companies from product, channel and market context, with relevance reasoning and a structured shortlist for review.",
    ],
    tr: [
      "Cernio — B2B şirket keşfi ve uygunluk değerlendirmesi | GADULABS",
      "Cernio; ürün, kanal ve pazar bağlamından hareketle aday şirketleri keşfetmeye, uygunluk gerekçelerini incelemeye ve araştırmayı sürdürmeye yardımcı olur.",
    ],
  },
  {
    path: "/projects/dose-modernization",
    en: [
      "DOSE Modernization — Corporate web experience | GADULABS",
      "Explore the DOSE corporate website modernization for Atlantik Tüketim Malları, with real website screenshots, product catalog details and a live reference.",
    ],
    tr: [
      "DOSE Modernization — Kurumsal web deneyimi | GADULABS",
      "Atlantik Tüketim Malları ve DOSE markası için kurumsal web modernizasyonu. Gerçek ekran görüntüleri, ürün kataloğu ve yayındaki siteyi inceleyin.",
    ],
  },
  {
    path: "/projects/kampanyambenim",
    en: [
      "KampanyamBenim — Early-stage product initiative | GADULABS",
      "KampanyamBenim is in early development. The initiative aims to make credit-card campaigns easier to understand and compare. It is not a finished product.",
    ],
    tr: [
      "KampanyamBenim — Erken aşamada ürün geliştirme | GADULABS",
      "KampanyamBenim erken geliştirme aşamasındadır. Kredi kartı kampanyalarını anlaşılır ve karşılaştırılabilir hâle getirmeyi amaçlayan, henüz tamamlanmamış bir girişimdir.",
    ],
  },
  {
    path: "/company",
    en: [
      "Company — GADULABS software and product engineering",
      "Learn about GADULABS, a product-focused software company founded in August 2026 in Türkiye. Company details, engineering approach and contact information.",
    ],
    tr: [
      "Şirket — GADULABS yazılım ve ürün geliştirme",
      "Ağustos 2026’da kurulan Türkiye merkezli GADULABS’ı tanıyın. Ürün odaklı yazılım yaklaşımımız, şirket bilgilerimiz ve iletişim adresimiz.",
    ],
  },
  {
    path: "/privacy",
    en: [
      "Privacy Policy — GADULABS",
      "How GADULABS handles email inquiries and website infrastructure data. This site does not use visitor analytics or session recording.",
    ],
    tr: [
      "Gizlilik Politikası — GADULABS",
      "GADULABS’ın e-posta talepleri ve web altyapısıyla ilgili veri işleme açıklaması. Bu sitede ziyaretçi analitiği veya oturum kaydı kullanılmaz.",
    ],
  },
  {
    path: "/terms",
    en: [
      "Terms of Use — GADULABS",
      "Terms for using the GADULABS corporate website, including informational content, intellectual property, external links and company contact details.",
    ],
    tr: [
      "Kullanım Koşulları — GADULABS",
      "GADULABS kurumsal web sitesinin kullanım koşulları: bilgilendirme amaçlı içerik, fikri mülkiyet, dış bağlantılar ve şirket iletişim bilgileri.",
    ],
  },
];
export function languagePath(pathname) {
  const clean = pathname.replace(/\/+$/, "") || "/";
  const lang = clean === "/tr" || clean.startsWith("/tr/") ? "tr" : "en";
  return { lang, path: lang === "tr" ? clean.slice(3) || "/" : clean };
}
export function localizedPath(to, lang) {
  if (!to.startsWith("/") || to.startsWith("//")) return to;
  const { path } = languagePath(to.split(/[?#]/)[0]);
  const suffix = to.slice(to.split(/[?#]/)[0].length);
  return (lang === "tr" ? "/tr" + (path === "/" ? "" : path) : path) + suffix;
}
const escape = (value) =>
  String(value).replace(
    /[&<>"']/g,
    (c) =>
      ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[
        c
      ],
  );
export function pageMetadata(pathname) {
  const { lang, path } = languagePath(pathname);
  const page = pages.find((p) => p.path === path);
  const [title, description] = page
    ? page[lang]
    : lang === "tr"
      ? [
          "Sayfa bulunamadı — GADULABS",
          "Aradığınız sayfa bulunamadı. GADULABS ana sayfasına dönün.",
        ]
      : [
          "Page not found — GADULABS",
          "This page could not be found. Return to the GADULABS homepage.",
        ];
  const url = ORIGIN + localizedPath(page ? page.path : "/404", lang);
  const organization = {
    "@type": "Organization",
    "@id": ORIGIN + "/#organization",
    name: "GADULABS",
    legalName: "GADULABS YAZILIM LİMİTED ŞİRKETİ",
    url: ORIGIN,
    logo: ORIGIN + "/logo.png",
    email: "info@gadulabs.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "Mustafa Kemal Paşa Mah. Yalova-Bursa Yolu Cad. A Blok 1. Kademe No: 123/1, İç Kapı No: 10",
      addressLocality: "Merkez / Yalova",
      addressCountry: "TR",
    },
  };
  const graph = [
    organization,
    {
      "@type": "WebSite",
      "@id": ORIGIN + "/#website",
      url: ORIGIN,
      name: "GADULABS",
      publisher: { "@id": organization["@id"] },
      inLanguage: ["en", "tr"],
    },
    {
      "@type": "WebPage",
      "@id": url + "#webpage",
      url,
      name: title,
      description,
      inLanguage: lang,
      isPartOf: { "@id": ORIGIN + "/#website" },
      about: { "@id": organization["@id"] },
    },
  ];
  if (page && path !== "/")
    graph.push({
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "GADULABS",
          item: ORIGIN + localizedPath("/", lang),
        },
        {
          "@type": "ListItem",
          position: 2,
          name: title.split(" — ")[0],
          item: url,
        },
      ],
    });
  return { lang, title, description, url, page, graph };
}
export function renderHead(pathname) {
  const { lang, title, description, url, page, graph } = pageMetadata(pathname);
  const meta = (key, value, property = false) =>
    `<meta data-site-meta ${property ? "property" : "name"}="${key}" content="${escape(value)}">`;
  const image = ORIGIN + "/images/og-gadulabs.png";
  return [
    `<title data-site-meta>${escape(title)}</title>`,
    meta("description", description),
    meta(
      "robots",
      page ? "index,follow,max-image-preview:large" : "noindex,follow",
    ),
    `<link data-site-meta rel="canonical" href="${url}">`,
    ...(page
      ? ["en", "tr", "x-default"].map(
          (l) =>
            `<link data-site-meta rel="alternate" hreflang="${l}" href="${ORIGIN + localizedPath(page.path, l === "tr" ? "tr" : "en")}">`,
        )
      : []),
    meta("og:type", "website", true),
    meta("og:site_name", "GADULABS", true),
    meta("og:title", title, true),
    meta("og:description", description, true),
    meta("og:url", url, true),
    meta("og:locale", lang === "tr" ? "tr_TR" : "en_GB", true),
    meta("og:locale:alternate", lang === "tr" ? "en_GB" : "tr_TR", true),
    meta("og:image", image, true),
    meta("og:image:width", "1200", true),
    meta("og:image:height", "630", true),
    meta(
      "og:image:alt",
      "GADULABS — Software for complex business problems",
      true,
    ),
    meta("twitter:card", "summary_large_image"),
    meta("twitter:title", title),
    meta("twitter:description", description),
    meta("twitter:image", image),
    meta(
      "twitter:image:alt",
      "GADULABS — Software for complex business problems",
    ),
    `<script data-site-meta type="application/ld+json">${JSON.stringify({ "@context": "https://schema.org", "@graph": graph }).replace(/</g, "\\u003c")}</script>`,
  ].join("\n");
}
